import React from 'react';
import { Box, Typography, Grid, IconButton, Divider } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import Logo from '../assets/IZ-Logo.png';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        backgroundColor: '#000',
        color: '#fff',
        padding: { xs: '1.5rem 1rem', sm: '1.5rem 2rem', md: '2rem 3rem' },
        width: '100%',
        mt: 'auto',
        boxSizing: 'border-box',
      }}
    >
      <Grid
        container
        spacing={0}
        sx={{
          maxWidth: { xs: '100%', md: '1200px' },
          width: '100%',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: 'row',
        }}
      >
        <Grid
          item
          xs={6}
          sm={4}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            pl: { xs: 0, md: 1 },
          }}
        >
          <Box
            component="img"
            src={Logo}
            alt="IZSOFTWARE HUB Logo"
            sx={{
              height: { xs: '30px', sm: '36px', md: '50px' },
              mr: { xs: 0.5, md: 1 },
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'scale(1.1) rotate(5deg)',
              },
            }}
          />
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '1rem', sm: '1.1rem', md: '1.4rem' },
              whiteSpace: 'nowrap',
              position: 'relative',
              display: { xs: 'none', sm: 'block' },
              '&:hover': {
                '&::after': {
                  width: '100%',
                },
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '-2px',
                left: 0,
                width: '0%',
                height: '2px',
                background: 'linear-gradient(90deg, #009db9 0%, #007a8a 100%)',
                transition: 'width 0.3s ease',
              },
            }}
          >
            IZSoftware Hub
          </Typography>
          {/* Mobile-only brand name */}
          <Typography
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '0.85rem', sm: '1.1rem', md: '1.4rem' },
              whiteSpace: 'nowrap',
              position: 'relative',
              display: { xs: 'block', sm: 'none' },
              '&:hover': {
                '&::after': {
                  width: '100%',
                },
              },
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: '-2px',
                left: 0,
                width: '0%',
                height: '2px',
                background: 'linear-gradient(90deg, #009db9 0%, #007a8a 100%)',
                transition: 'width 0.3s ease',
              },
            }}
          >
            IZSoftwares
          </Typography>
        </Grid>

        {/* Social Icons Section - Always right aligned */}
        <Grid
          item
          xs={6}
          sm={4}
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            pr: { xs: 0, md: 1 },
          }}
        >
          <IconButton
            href="https://www.linkedin.com/company/izsoftwares/posts/?feedView=all"
            target="_blank"
            sx={{
              color: '#fff',
              padding: { xs: '8px', sm: '6px', md: '8px' },
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'scale(1.2)',
                color: '#0e76a8',
              },
            }}
          >
            <LinkedInIcon sx={{ fontSize: { xs: '1.4rem', sm: '1.5rem', md: '1.8rem' } }} />
          </IconButton>
          <IconButton
            href="https://x.com/IZSoftwares"
            target="_blank"
            sx={{
              color: '#fff',
              padding: { xs: '8px', sm: '6px', md: '8px' },
              transition: 'transform 0.3s ease',
              '&:hover': {
                transform: 'scale(1.2)',
                color: '#1DA1F2',
              },
            }}
          >
            <TwitterIcon sx={{ fontSize: { xs: '1.4rem', sm: '1.5rem', md: '1.8rem' } }} />
          </IconButton>
        </Grid>
      </Grid>

      <Divider
        sx={{
          backgroundColor: '#666',
          my: { xs: 1, sm: 1.5, md: 2 },
          maxWidth: { xs: '100%', md: '1200px' },
          width: '100%',
          margin: '0 auto',
        }}
      />

      <Typography
        variant="body2"
        sx={{
          textAlign: 'center',
          maxWidth: { xs: '100%', md: '1200px' },
          width: '100%',
          margin: '0 auto',
          mt: { xs: 1, sm: 1.5, md: 2 },
          fontSize: { xs: '0.75rem', sm: '0.8rem', md: '0.9rem' },
          px: { xs: 1, md: 0 },
          lineHeight: { xs: 1.3, sm: 1.4, md: 1.5 },
          opacity: 0.9,
          letterSpacing: { xs: 0, sm: 0.5, md: 1 },
        }}
      >
        Copyright © {currentYear} Evolv IZSoftwares Group Ltd. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;